const defaultTheme = {
  colors: {
    primaryBg: '#F2F2F2',
    primaryText: '#515151',
    base: {
      slot1: '#0086FF',
      slot2: '#0073DB',
      slot3: '#A400E1',
      slot4: '#FF37A8',
      slot5: '#FF8A00'
    },
    grayscale: {
      slot1: '#FFFFFF',
      slot2: '#F2F2F2',
      slot3: '#C6C6C6',
      slot4: '#AEAEAE',
      slot5: '#9B9B9B',
      slot6: '#515151'
    },
    support: {
      slot1: '#FFCE00',
      slot2: '#FF253A',
      slot3: '#59C00B',
      slot4: '#1992FF'
    },
    interaction: {
      slot1: '#0086FF'
    }
  },
  fonts: {
    weight: {
      '400': 'Roboto_400',
      '500': 'Roboto_500',
      '700': 'Roboto_700'
    }
  }
};

export default defaultTheme;
